<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files /   {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createFunction.show()"
          v-if="role_modules.some(item => item.value == 'function.create')"
        >
          <i class="uil-plus mr-1"></i> {{$t('function.action.create_record')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <Table
        ref="list"
        :useView="role_modules.some(item => item.value == 'function.view')"
        :useEdit="role_modules.some(item => item.value == 'function.edit')"
        noTitle
        :params="params"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'function') ? action : false"
        @openFormBar="openFormBar"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Function"
      ref="viewFunction"
      size="md"
      :component="viewComponent"
      :parameters="{ functionID, submitted }"
      v-if="role_modules.some(item => item.value == 'function.view')"
    />
    <Dialog
      centered
      autoload
      is_reset_model
      title="Create Function"
      ref="createFunction"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateFunction"
      v-if="role_modules.some(item => item.value == 'function.create')"
    />
    <Dialog
      centered
      autoload
      title="Update Function"
      ref="editFunction"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{ functionID, submitted }"
      @onYes="onUpdateFunction"
      v-if="role_modules.some(item => item.value == 'function.edit')"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import ViewComponent from './components/dialogs/view.vue'
import EditComponent from './components/dialogs/edit.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    createComponent () {
      return CreateComponent
    },
    viewComponent () {
      return ViewComponent
    },
    editComponent () {
      return EditComponent
    }
  },
  data() {
    return {
      fields: [
				{
          label: this.$t('function.table.name'), 
          key:"name",
          sortable: true
        },
        {
          label: this.$t('function.table.date_created'), 
          key:'date_created', formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'function/pagination',
      functionID: '',
      submitted: false,
      created: false,
      updated: false,
    }
  },
  methods: {
    openFormBar(id, editMode = false) {
      this.functionID = id
      if(!editMode){
        this.$refs.viewFunction.show()
        // this.$router.push(`/master_files/function/view?id=${id}`)
      }else{
        this.$refs.editFunction.show()
        // this.$router.push(`/master_files/function/edit?id=${id}`)
      }
    },
    
    onCreateFunction(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('function/create', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.createFunction.hide();
          this.$bvToast.toast('Function successfully created!', {
            title: "Notification",
            variant: "success"
          });
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onUpdateFunction(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('function/update', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.editFunction.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Function successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
  }
}
</script>